import { gsap } from '../_snowpack/pkg/gsap.js';

const ACTIVE = 'active';

document.addEventListener('DOMContentLoaded', function onDOMLoaded() {
  const $accordionItems = document.querySelectorAll('.accordion-title');
  const timeline = gsap.timeline();

  const isRTL = document.dir === 'rtl';

  $accordionItems.forEach((el) => {
    el.addEventListener('click', function onClick(e) {
      e.preventDefault();
      e.stopPropagation();

      const { target: targetEl } = e;
      const parent = targetEl.parentNode;

      const $accordionContent = parent.querySelector('.accordion-content');
      const $arrow = parent.querySelector('.arrow');

      if (!targetEl.classList.contains(ACTIVE)) {
        targetEl.classList.add(ACTIVE);
        timeline
          .to($accordionContent, { height: 'auto', duration: 0.3 })
          .to($accordionContent, { y: 0, opacity: 1, duration: 0.3 }, '<0.1')
          .to($arrow, { rotation: 90, duration: 0.2 }, '<');
      } else {
        targetEl.classList.remove(ACTIVE);
        timeline
          .to($arrow, { rotation: isRTL ? 180 : 0, duration: 0.2 })
          .to($accordionContent, { height: 0, duration: 0.3 }, '<')
          .to($accordionContent, { y: 0, opacity: 0, duration: 0.3 }, '<-0.1');
      }
    });
  });
});
